import styles from './ManageTeam.module.css';
import Header from "../../components/common/header/Header";
import { useEffect } from "react";
import Container from "react-bootstrap/Container";
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MdAdd } from "react-icons/md";
import Input from '../../components/common/input/Input';
import Table from 'react-bootstrap/Table'
import Badge from 'react-bootstrap/Badge'
import { useState } from 'react';
import ManageTeamProfile from './../../components/manage-team-profile/ManageTeamProfile';
import { deleteTeamById, getAllTeams } from '../../services/Team.service';
import { useHistory } from "react-router-dom";
import { userSelector } from '../../hooks/store/getters';
import { useAppStore } from './../../hooks/store/useAppStore';
import { USER_ROLES } from './../../constants/UserRoles.const';

const ManageTeam = () => {
    // const users = useAppStore(usersSelector);
    // const setUsers = useAppStore(setUsersSelector);
    
    const history = useHistory();
    
    const user = useAppStore(userSelector);
    
    const [teams, setTeams] = useState([])
    const [filteredTeams, setFilteredTeams] = useState([])
    const [showManageTeam, setShowManageTeam] = useState(false)
    const [profleViewMode, setProfleViewMode] = useState(false)
    const [manageTeam, setManageTeam] = useState(null)
    const [filters, setFilters] = useState({
        searchStr: "",
        role: ''
    })

    useEffect(()=>{
        const getTeams = async () => {
            const teams = await getAllTeams();
            const filtered = teams.filter(t => {
                if (
                    t.members.find(u => u.uid === user.uid) ||
                    user.userRole === USER_ROLES.ADMIN ||
                    user.userRole === USER_ROLES.MANAGER
                ) {
                    return true
                } else {
                    return false
                }
            })
            console.log('filtered', filtered)
            setTeams(filtered);
        }
        getTeams();
    },[setTeams, user])
    
    useEffect(() => {
        console.log('filters changed ', filters);
        
        const searchStr = filters.searchStr.toLowerCase()
        
        const filteredTeams = teams.filter(team => {
            if (
                team.teamName.toLowerCase().includes(searchStr) ||
                team.description.toLowerCase().includes(searchStr)
            ) {
                return true
            }
            
            return false
        })
        
        setFilteredTeams(filteredTeams)
        
    }, [teams, filters, setFilteredTeams])
    
    const updateFilterData = ({ target: { name, value } }) => {
        console.log('update filer', {name, value});
        
        setFilters({
            ...filters,
            [name]: value
        })
    }
    
    const closeManageProfile = (updatedTeam) => {
        console.log('closeManageTeam', updatedTeam);
        if (updatedTeam) {
            const { newlyAdded=false, isDeleted=false, ...data } = updatedTeam;
            
            if (newlyAdded) {
                setTeams([
                    ...teams,
                    { ...data }
                ])
            } else if (isDeleted) {
                setTeams([
                    ...teams.filter(t => t.id !== data.id)
                ])
            } else {
                setTeams([
                    ...teams.map(u => {
                        if (u.id === updatedTeam.id) {
                            return {
                                ...u,
                                ...updatedTeam
                            }
                        }
                        return u
                    })
                ])
            }
            
        }
        
        setShowManageTeam(false)
        setManageTeam(null)
        setProfleViewMode(false)
    }
    
    const openManageTeam = () => {
        setShowManageTeam(true)
    }
    
    
    const manageProfile = team => {
        setManageTeam(team)
        openManageTeam()
    }
    
    const deleteTeam = async (team) => {
        const alertMsg = `Do you want to delete team : ${team.teamName}?`
        if (window.confirm(alertMsg)) {
            const result = await deleteTeamById(team.id)
            closeManageProfile(result)
        }
    }
    
    const viewProfile = team => {
        setProfleViewMode(true)
        setManageTeam(team)
        openManageTeam()
    }
    
    const viewTeamTours = team => {
        history.push('/team-tours/' + team.id)
    }
    
    const viewTeamToursMap = team => {
        history.push('/team-tour-map/' + team.id)
    }
    

    return (  
        <div className={styles.userListWraper}>
            <Header />
            <Container fluid="md">
                
                {/* Header */}
                <div className={styles.userListHeader}>
                    <Row className="align-items-center">
                        <Col md={9} sm={12}>
                            <div>
                                <h1>Manage Teams</h1>
                                <p>
                                    View, Add and Edit Teams
                                </p>
                            </div>
                        </Col>
                        { user.userRole === USER_ROLES.ADMIN ? <Col md={3} sm={12}>
                            <Button variant="warning" size="lg" className={styles.createUserBtn}
                                onClick={openManageTeam}
                            >
                                <span className={styles.btnText}>Create Team</span>
                                <MdAdd className={styles.btnIcon} />
                            </Button>
                        </Col> : null }
                    </Row>
                </div>
                {/* Header */}
                
                {/* Filters */}
                <div className={styles.TourListFilter}>
                    <Row className="w-100">
                        <Col md={5} sm={12}>
                        <Input
                                variant="dark"
                                placeholder="Search Team"
                                name="searchStr"
                                value={filters.searchStr}
                                onChange={(e) => updateFilterData(e)}
                            />
                        </Col>
                    </Row>
                </div>
                {/* Filters */}
                
                <Table striped borderless hover className={styles.userTable}>
                    <thead>
                        <tr>  
                            <th>Name</th>  
                            <th>Description</th>  
                            <th>Total Members</th>  
                            <th>Action</th>  
                        </tr>
                    </thead>
                    
                    <tbody>
                        { filteredTeams.map((team, index) => (  
                            <tr data-index={index} key={index}>  
                                <td>{team.teamName}</td>  
                                <td>{team.description}</td>  
                                <td>{team.members.length}</td>  
                                <td>
                                    <Badge 
                                        pill 
                                        variant="info"
                                        className={styles.actionPill} 
                                        onClick={() => viewProfile(team)}
                                    >View</Badge>
                                    { user.userRole === USER_ROLES.ADMIN ? <Badge 
                                        pill 
                                        variant="warning"
                                        className={styles.actionPill} 
                                        onClick={() => manageProfile(team)}
                                    >Edit</Badge> : null }
                                    { user.userRole === USER_ROLES.ADMIN ? <Badge 
                                        pill 
                                        variant="danger"
                                        className={styles.actionPill} 
                                        onClick={() => deleteTeam(team)}
                                    >Delete</Badge> : null }
                                    <Badge 
                                        pill 
                                        variant="success"
                                        className={styles.actionPill} 
                                        onClick={() => viewTeamTours(team)}
                                    >Tours</Badge>
                                    <Badge 
                                        pill 
                                        variant="dark"
                                        className={styles.actionPill} 
                                        onClick={() => viewTeamToursMap(team)}
                                    >Tours Map (Only Public)</Badge>
                                </td>
                            </tr>  
                        ))}
                    </tbody>
                </Table>
            </Container>
        
            {
                showManageTeam && <ManageTeamProfile 
                    show={showManageTeam}
                    onClose={closeManageProfile}
                    user={manageTeam}
                    viewMode={profleViewMode}
                />
            }
            
        </div>
    );  
}
export default ManageTeam;